;(function() {
// UI Bootstrap 1.3.x exposes templateUrl for the whole day/month view, but no
// separate header template. Independent year/month controls therefore require
// replacing these view templates; CSS alone cannot add their navigation actions.
// The library's controllers still handle selection and date limits, and its year
// template remains unchanged. Compare the copied day/month grids when upgrading
// UI Bootstrap so they stay compatible with its controllers.
/* @ngInject */
function configureDatepickerTemplates($provide) {
    [
        { directive: "uibDaypickerDirective", template: "day" },
        { directive: "uibMonthpickerDirective", template: "month" }
    ].forEach(function (picker) {
        $provide.decorator(picker.directive, ["$delegate", function ($delegate) {
            $delegate[0].templateUrl = function (element, attrs) {
                return attrs.templateUrl || "/app/shared/datepicker/" + picker.template + ".html";
            };
            return $delegate;
        }]);
    });
}

angular.module("firmaren")
    .config(configureDatepickerTemplates);
}());
